/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const TablePhoneIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 88 96"
    onClick={props.onClick}
  >
    <g strokeWidth="2.5">
      <path d="M38 86c0 4.416-3.584 8-8 8H18c-4.416 0-8-3.584-8-8V22c0-4.416 3.584-8 8-8h12c4.416 0 8 3.584 8 8v64zM38 26h44c2.2 0 4 1.8 4 4v52c0 2.2-1.8 4-4 4H38M10 86H6c-2.2 0-4-1.8-4-4V30c0-2.2 1.8-4 4-4h4" />
      <path d="M50 34h24v8H50z" />
      <path d="M18 14V2" />
      <path d="M52 52h-4v4h4zM64 52h-4v4h4zM76 52h-4v4h4zM52 60h-4v4h4zM64 60h-4v4h4zM76 60h-4v4h4zM52 68h-4v4h4zM64 68h-4v4h4zM76 68h-4v4h4z" />
    </g>
  </svg>
);

export default TablePhoneIcon;
